import type {
  CardPartner,
  Eligibility as EligibilityDto,
  FeatureDataResponse,
  FeatureSchemaResponse,
  Template,
} from '@api/swagger/definitions/backoffice'
import type { Eligibility, Feature, FeatureItem, TemplateFeature } from '../types'

export const mapTemplateDtoToTemplate = (dtoTemplate: Template) => {
  return {
    id: dtoTemplate.id || '',
    name: dtoTemplate.name || '',
    externalName: dtoTemplate.externalName || '',
    features: [] as TemplateFeature[],
  }
}

export const mapFeatureSchemaDtoToFeature = (featureSchemaDto: any): Feature => {
  const formattedFeature = {
    id: featureSchemaDto.featureId,
    name: featureSchemaDto.name,
    type: featureSchemaDto.schema.type,
    required: false,
    value: '',
  }

  // TODO: Actually map objects properly
  if (featureSchemaDto.schema.type === 'composite') {
    formattedFeature.required = false
  } else {
    formattedFeature['defaultValue'] = featureSchemaDto.schema.defaultValue
    formattedFeature.value = featureSchemaDto.schema.defaultValue
    formattedFeature.required = featureSchemaDto.schema.required
  }

  return formattedFeature
}

export const mapTemplateFeatureToFeatureDto = (feature: TemplateFeature) => {
  return {
    id: feature.id,
    data: {
      type: feature.type,
      value: feature.value,
    },
  }
}

export const mapEligibilityToEligibilityDto = (eligibility: Eligibility): EligibilityDto => {
  return {
    partners: {
      type: eligibility.partners.type,
      partners: eligibility.partners.partners as CardPartner[],
    },
    currencies: {
      type: eligibility.currencies.type,
      currencies: eligibility.currencies.currencies,
    },
    countries: {
      type: eligibility.countries.type,
      countries: eligibility.countries.countries,
    },
  }
}

export const mapFeatureSchemaAndFeatureItemToTemplateFeature = ({
  featureSchema,
  featureItem,
}: {
  featureSchema: FeatureSchemaResponse
  featureItem: FeatureDataResponse | FeatureItem
}) => {
  return {
    id: featureSchema.featureId,
    name: featureSchema.name,
    type: featureSchema.schema.type,
    value: featureItem.data.value,
  }
}
